<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconcaidan1"></i>
      菜单管理
    </div>
    <div class="padding-sm">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="总管理员" name="first">
          <el-table
              :data="menus0"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
                            <template slot-scope="scope">
                              <div >
                                <i class="iconfont" :class="scope.row.icon"></i>
                              </div>
                            </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
<!--            <el-table-column-->
<!--                align="center"-->
<!--                label="状态">-->
<!--              <template slot-scope="scope">-->
<!--                <div >-->
<!--                  {{ scope.row.status === 0 ? '停用' : '正常' }}-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="项目办" name="second">
          <el-table
              :data="menus1"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
              <template slot-scope="scope">
                <div >
                  <i class="iconfont" :class="scope.row.icon"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
            <!--            <el-table-column-->
            <!--                align="center"-->
            <!--                label="状态">-->
            <!--              <template slot-scope="scope">-->
            <!--                <div >-->
            <!--                  {{ scope.row.status === 0 ? '停用' : '正常' }}-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="认证培训机构" name="third">
          <el-table
              :data="menus2"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
              <template slot-scope="scope">
                <div >
                  <i class="iconfont" :class="scope.row.icon"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
            <!--            <el-table-column-->
            <!--                align="center"-->
            <!--                label="状态">-->
            <!--              <template slot-scope="scope">-->
            <!--                <div >-->
            <!--                  {{ scope.row.status === 0 ? '停用' : '正常' }}-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="实习基地" name="fourth">
          <el-table
              :data="menus3"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
              <template slot-scope="scope">
                <div >
                  <i class="iconfont" :class="scope.row.icon"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
            <!--            <el-table-column-->
            <!--                align="center"-->
            <!--                label="状态">-->
            <!--              <template slot-scope="scope">-->
            <!--                <div >-->
            <!--                  {{ scope.row.status === 0 ? '停用' : '正常' }}-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="考场" name="fifth">
          <el-table
              :data="menus4"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
              <template slot-scope="scope">
                <div >
                  <i class="iconfont" :class="scope.row.icon"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="产教融合基地" name="sixth">
          <el-table
              :data="menus5"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
              <template slot-scope="scope">
                <div >
                  <i class="iconfont" :class="scope.row.icon"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="协调中心" name="seventh">
          <el-table
              :data="menus6"
              header-row-class-name="table-header"
              row-class-name="table-row"
              row-key="menu_id"
              alig="center"
              fit
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号">

            </el-table-column>
            <el-table-column label="栏目名称" prop="name"></el-table-column>
            <el-table-column label="栏目id" prop="menu_id" align="center"></el-table-column>
            <el-table-column label="栏目icon"  align="center">
              <template slot-scope="scope">
                <div >
                  <i class="iconfont" :class="scope.row.icon"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="栏目path" prop="path" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {menusList} from '@/api/admin'

export default {
  name: "menus",
  data() {
    return {
      activeName: 'first',
      menus0: [],
      menus1: [],
      menus2: [],
      menus3: [],
      menus4: [],
      menus5: [],
      menus6: [],
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "当前位置：系统管理 > <span>菜单管理</span>", false);
    this.getmenus(0)
    this.getmenus(1)
    this.getmenus(2)
    this.getmenus(3)
    this.getmenus(4)
    this.getmenus(5)
    this.getmenus(6)
  },
  methods: {
    async getmenus(num) {
      let _list = await menusList(num)
      switch (num) {
        case 0:
          this.menus0 = _list.data
          break
        case 1:
          this.menus1 = _list.data
          break
        case 2:
          this.menus2 = _list.data
          break
        case 3:
          this.menus3 = _list.data
          break
        case 4:
          this.menus4 = _list.data
          break
        case 5:
          this.menus5 = _list.data
          break
        case 6:
          this.menus6 = _list.data
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>